import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26e83b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "content-title" }
const _hoisted_3 = {
  class: "btn-toolbar",
  role: "toolbar",
  "aria-label": "Toolbar with button groups"
}
const _hoisted_4 = {
  class: "btn-group me-2 ms-5",
  role: "group",
  "aria-label": "Second group"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle fa-fw" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Third group"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save fa-fw" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.vm.content.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['btn', 'btn-light', _ctx.vm.readonly ? 'disabled' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'content' })))
        }, _hoisted_7, 2)
      ]),
      (!_ctx.vm.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(['btn', 'btn-success', _ctx.vm.readonly || !_ctx.vm.content.dirty ? 'disabled' : '']),
              disabled: _ctx.vm.readonly || !_ctx.vm.content.dirty,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
            }, _hoisted_12, 10, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}